import React from 'react';

/**
 * Champ de saisie texte long (textarea)
 */
function ChampTexteLong({ label, valeur, onChange, placeholder, infobulle, pleineLargeur, nom, lignes }) {
  return (
    <div className={`champ${pleineLargeur ? ' champ--pleine-largeur' : ''}`}>
      {label && <label className="champ__label">{label}</label>}
      <textarea
        className="champ__textarea"
        value={valeur}
        onChange={(e) => onChange(nom || label, e.target.value)}
        placeholder={placeholder || ''}
        rows={lignes || 4}
      />
      {infobulle && <span className="champ__infobulle">{infobulle}</span>}
    </div>
  );
}

export default ChampTexteLong;
